<template>
  <div class="index" @click="h5show = false">
    <div class="index-con">
      <div class="big-title-temp">
        <span class="big-title1"> {{ $t("organizingTitle1") }} </span>
        <span class="big-title"> <span>{{ $t("organizingTitle") }}</span></span>
      </div>
      <div class="big-title-img">
        <img src="../../static/jldx.jpg" width="200px">
      </div>
      <div class="small-title">{{ $t("organizingsmalltitle") }}</div>

      <div class="text">
        {{ $t("organizingtext1") }}
      </div>
      <div class="text">
        {{ $t("organizingtext2") }}
      </div>
      <!-- <div class="text">
        {{ $t("organizingtext3") }}
      </div>
      <div class="text">
        {{ $t("organizingtext4") }}
      </div> -->

      <!-- <div class="small-title">{{ $t("organizingsmalltitle2") }}</div>
      <div class="text">
        {{ $t("organizingtext5") }}
        <br />
      </div>
      <div class="text">
        <b> {{ $t("organizingaddresss") }}: </b>
        {{ $t("organizingaddressstext") }}
        <b> {{ $t("organizingtext10") }}: </b>
        {{ $t("organizingtext11") }}
      </div> -->
      <div class="text">
        <b>{{ $t("organizingdetails") }}</b>
        <a :href="$t('organizingtext12')" class="text-blue" target="_blank">
          {{ $t('organizingtext12') }}
        </a>
      </div>
      <!--div class="imgcenter">
        <img src="http://mk.chinaman.cn/mybigdatas/ids/static/organizer.jpg" />
      </！div-->
    </div>


    <div class="index-con">
      <div class="big-title1">
        {{ $t("coOrganizersBigTitle") }}
      </div>

    </div>




    <div class="index-con">
      <div class="big-title2">
        <span> {{ $t("coOrganizersTitleA1") }}</span>
      </div>
      <div class="big-title-img">
        <img src="http://mk.chinaman.cn/mybigdatas/ids/static/12/1IRADSTM.png" height="100px">
      </div>
      <div class="text">
        {{ $t("coOrganizersTextA1") }}
      </div>
    </div>


    <div class="index-con">
      <div class="big-title2">
        <span> {{ $t("coOrganizersTitleA2") }}</span>
      </div>
      <div class="big-title-img">
        <img src="http://mk.chinaman.cn/mybigdatas/ids/static/12/2中国通用机械工业协会干燥设备分会.jpg" height="100px">
      </div>
      <div class="text">
        {{ $t("coOrganizersTextA21") }}
      </div>
      <div class="text">
        {{ $t("coOrganizersTextA22") }}
      </div>
      <div class="text">
        {{ $t("coOrganizersTextA23") }}
      </div>

      <div class="text">
        <b> {{ $t("organizingaddresss") }}: </b>
        {{ $t("coOrganizersTextAB21") }}

      </div>
      <div class="text">
        <b>{{ $t("organizingdetails") }}</b>
        <a :href="$t('coOrganizersTextAB22')" class="text-blue" target="_blank">
          {{ $t('coOrganizersTextAB22') }}
        </a>
        <br><br>
      </div>
    </div>




    <div class="index-con">
      <div class="big-title2">
        <span> {{ $t("coOrganizersTitleA3") }}</span>
      </div>
      <div class="big-title-img">
        <img src="http://mk.chinaman.cn/mybigdatas/ids/static/12/3中国计量大学.jpg" height="100px">
      </div>
      <div class="text">
        {{ $t("coOrganizersTextA31") }}
      </div>
      <div class="text">
        {{ $t("coOrganizersTextA32") }}
      </div>
      <div class="text">
        <b> {{ $t("organizingaddresss") }}: </b>
        {{ $t("coOrganizersTextAB31") }}
      </div>
      <div class="text">
        <b>{{ $t("organizingdetails") }}</b>
        <a :href="$t('coOrganizersTextAB32')" class="text-blue" target="_blank">
          {{ $t('coOrganizersTextAB32') }}
        </a>
        <br><br>
      </div>
    </div>



    <div class="index-con">
      <div class="big-title2">
        <span> {{ $t("coOrganizersTitleA4") }}</span>
      </div>
      <div class="big-title-img">
        <img src="http://mk.chinaman.cn/mybigdatas/ids/static/12/4中国农业大学.jpg" height="100px">
      </div>
      <div class="text">
        {{ $t("coOrganizersTextA41") }}
      </div>
      <div class="text">
        {{ $t("coOrganizersTextA42") }}
      </div>
      <div class="text">
        <b> {{ $t("organizingaddresss") }}: </b>
        {{ $t("coOrganizersTextAB41") }}
      </div>
      <div class="text">
        <b>{{ $t("organizingdetails") }}</b>
        <a :href="$t('coOrganizersTextAB42')" class="text-blue" target="_blank">
          {{ $t('coOrganizersTextAB42') }}
        </a>
        <br><br>
      </div>
    </div>





    <div class="index-con">
      <div class="big-title2">
        <span> {{ $t("coOrganizersTitleA5") }}</span>
      </div>
      <div class="big-title-img">
        <img src="http://mk.chinaman.cn/mybigdatas/ids/static/12/5北京交通大学.jpg" height="100px">
      </div>
      <div class="text">
        {{ $t("coOrganizersTextA51") }}
      </div>

      <div class="text">
        <b> {{ $t("organizingaddresss") }}: </b>
        {{ $t("coOrganizersTextAB51") }}
      </div>
      <div class="text">
        <b>{{ $t("organizingdetails") }}</b>
        <a :href="$t('coOrganizersTextAB52')" class="text-blue" target="_blank">
          {{ $t('coOrganizersTextAB52') }}
        </a>
        <br><br>
      </div>
    </div>



    <div class="index-con">
      <div class="big-title2">
        <span> {{ $t("coOrganizersTitleA6") }}</span>
      </div>
      <div class="big-title-img">
        <img src="http://mk.chinaman.cn/mybigdatas/ids/static/12/6中国农业科学院农产品加工研究所.png" height="100px">
      </div>
      <div class="text">
        {{ $t("coOrganizersTextA61") }}
      </div>

      <div class="text">
        <b> {{ $t("organizingaddresss") }}: </b>
        {{ $t("coOrganizersTextAB61") }}
      </div>
      <div class="text">
        <b>{{ $t("organizingdetails") }}</b>
        <a :href="$t('coOrganizersTextAB62')" class="text-blue" target="_blank">
          {{ $t('coOrganizersTextAB62') }}
        </a>
        <br><br>
      </div>
    </div>



    <div class="index-con">
      <div class="big-title2">
        <span> {{ $t("coOrganizersTitleA7") }}</span>
      </div>
      <div class="big-title-img">
        <img src="http://mk.chinaman.cn/mybigdatas/ids/static/12/7江苏省农业科学院.jpg" height="100px">
      </div>
      <div class="text">
        {{ $t("coOrganizersTextA71") }}
      </div>
      <div class="text">
        {{ $t("coOrganizersTextA72") }}
      </div>
      <div class="text">
        <b> {{ $t("organizingaddresss") }}: </b>
        {{ $t("coOrganizersTextAB71") }}
      </div>
      <div class="text">
        <b>{{ $t("organizingdetails") }}</b>
        <a :href="$t('coOrganizersTextAB72')" class="text-blue" target="_blank">
          {{ $t('coOrganizersTextAB72') }}
        </a>
        <br><br>
      </div>
    </div>



    <div class="index-con">
      <div class="big-title2">
        <span> {{ $t("coOrganizersTitleA8") }}</span>
      </div>
      <div class="big-title-img">
        <img src="http://mk.chinaman.cn/mybigdatas/ids/static/12/8陕西科技大学.jpg" height="100px">
      </div>
      <div class="text">
        {{ $t("coOrganizersTextA81") }}
      </div>

      <div class="text">
        <b> {{ $t("organizingaddresss") }}: </b>
        {{ $t("coOrganizersTextAB81") }}
      </div>
      <div class="text">
        <b>{{ $t("organizingdetails") }}</b>
        <a :href="$t('coOrganizersTextAB82')" class="text-blue" target="_blank">
          {{ $t('coOrganizersTextAB82') }}
        </a>
        <br><br>
      </div>
    </div>



    <div class="index-con">
      <div class="big-title2">
        <span> {{ $t("coOrganizersTitleA9") }}</span>
      </div>
      <div class="big-title-img">
        <img src="http://mk.chinaman.cn/mybigdatas/ids/static/12/9苏州大学.png" height="100px">
      </div>
      <div class="text">
        {{ $t("coOrganizersTextA91") }}
      </div>

      <div class="text">
        <b> {{ $t("organizingaddresss") }}: </b>
        {{ $t("coOrganizersTextAB91") }}
      </div>
      <div class="text">
        <b>{{ $t("organizingdetails") }}</b>
        <a :href="$t('coOrganizersTextAB92')" class="text-blue" target="_blank">
          {{ $t('coOrganizersTextAB92') }}
        </a>
        <br><br>
      </div>
    </div>




    <div class="index-con">
      <div class="big-title2">
        <span> {{ $t("coOrganizersTitleA10") }}</span>
      </div>
      <div class="big-title-img">
        <img src="http://mk.chinaman.cn/mybigdatas/ids/static/12/10贺州学院.jpg" height="100px">
      </div>
      <div class="text">
        {{ $t("coOrganizersTextA101") }}
      </div>

      <div class="text">
        <b> {{ $t("organizingaddresss") }}: </b>
        {{ $t("coOrganizersTextAB101") }}
      </div>
      <div class="text">
        <b>{{ $t("organizingdetails") }}</b>
        <a :href="$t('coOrganizersTextAB102')" class="text-blue" target="_blank">
          {{ $t('coOrganizersTextAB102') }}
        </a>
        <br><br>
      </div>
    </div>



    <div class="index-con">
      <div class="big-title2">
        <span> {{ $t("coOrganizersTitleA11") }}</span>
      </div>
      <div class="big-title-img">
        <img src="http://mk.chinaman.cn/mybigdatas/ids/static/12/浙江科技大学.jpg" height="100px">
      </div>
      <div class="text">
        {{ $t("coOrganizersTextA111") }}
      </div>
      <div class="text">
        {{ $t("coOrganizersTextA112") }}
      </div>
      <div class="text">
        <b> {{ $t("organizingaddresss") }}: </b>
        {{ $t("coOrganizersTextAB111") }}
      </div>
      <div class="text">
        <b>{{ $t("organizingdetails") }}</b>
        <a :href="$t('coOrganizersTextAB112')" class="text-blue" target="_blank">
          {{ $t('coOrganizersTextAB112') }}
        </a>
        <br><br>
      </div>
    </div>



    <div class="index-con">
      <div class="big-title2">
        <span> {{ $t("coOrganizersTitleA12") }}</span>
      </div>
      <div class="big-title-img">
        <img src="http://mk.chinaman.cn/mybigdatas/ids/static/12/12广东省农业科学院蚕业与农产品加工研究所.jpg" height="100px">
      </div>
      <div class="text">
        {{ $t("coOrganizersTextA121") }}
      </div>
      <div class="text">
        {{ $t("coOrganizersTextA122") }}
      </div>
      <div class="text">
        <b> {{ $t("organizingaddresss") }}: </b>
        {{ $t("coOrganizersTextAB121") }}
      </div>
      <div class="text">
        <b>{{ $t("organizingdetails") }}</b>
        <a :href="$t('coOrganizersTextAB122')" class="text-blue" target="_blank">
          {{ $t('coOrganizersTextAB122') }}
        </a>
        <br><br>
      </div>
    </div>


  </div>
</template>

<script>
export default {
  data() {
    return {
      h5show: false,
    };
  },
  methods: {},
};
</script>

<style scoped>
.imgcenter {
  width: 100%;
  padding: 20px 200px 20px 200px;
}

.imgcenter img {
  width: 70%;
}

.big-title-temp {
  color: #0a9a7a;
  text-align: center;
  line-height: 40px;
  font-weight: 600;
  margin-bottom: 70px;
  margin-top: 50px;
  position: relative;
}

.big-title1 {
  color: #0a9a7a;
  text-align: center;
  line-height: 40px;
  font-weight: 600;
  margin-bottom: 70px;
  margin-top: 50px;
  font-size: 28px;
}

.big-title2 {
  color: #0a9a7a;
  text-align: center;
  line-height: 40px;
  font-weight: 600;
  margin-bottom: 70px;
  margin-top: 50px;
  position: relative;

}

.big-title2 span {
  position: relative;
  font-size: 21px;
}

.big-title2 span::after {
  content: "";
  bottom: -10px;
  left: 10px;
  height: 4px;
  right: 10px;
  text-align: center;
  background: #0a9a7a;
  position: absolute;
}

.big-title-img {
  text-align: center;
  margin-top: -50px;
  margin-bottom: 10px;
}

.big-abouttitle {
  color: red;
  text-align: center;
  margin-top: -60px;
  margin-bottom: -10px;
  font-size: 15px;
  font-weight: 600;
}

.top {
  top: 150px;
  left: 0;
  background: #fff;
  height: 70px;
  box-sizing: border-box;
  z-index: 99;
  width: 100%;
  border-top: 10px solid #0a9a7a;
}

.small-title {
  font-size: 17px;
  font-weight: 600;
  margin-bottom: 20px;
}

.index-con {
  margin: 0 auto;
  width: 1200px;
}

.text {
  color: #333;
  text-indent: 2em;
  line-height: 2;
  padding-bottom: 20px;
}

.text-blue {
  color: #428bca;
  cursor: pointer;
}

.top-bg {
  background-image: url("https://img0.baidu.com/it/u=2363835659,3802656139&fm=253&fmt=auto&app=138&f=JPEG?w=1180&h=492");
  background-size: 100% auto;
  height: 150px;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99;
  width: 100vw;
}

@media screen and (max-width: 768px) {
  .imgcenter {
    padding: 30px 0;
    text-align: center;
  }

  .imgcenter img {
    width: 100%;
  }

  .index-con {
    width: 100%;
  }

  .title {
    font-size: 18px;
  }

  .index {
    padding: 40px 10px 0;
    box-sizing: border-box;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/organizing.vue